"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineDistanceCalcNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const distance_1 = __importDefault(require("@turf/distance"));
const Schema = __importStar(require("./schema.json"));
const helpers_1 = require("../../../utils/helpers");
const NODE_TYPE = 'LINE-DISTANCE-CALC';
class LineDistanceCalcNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            try {
                const existingLine = (0, helpers_1.getLineFromString)(params.line);
                if (existingLine) {
                    let dist = 0;
                    const arr = [];
                    let previousCoord;
                    existingLine.coordinates.forEach(coord => {
                        if (previousCoord) {
                            const d = (0, distance_1.default)(previousCoord, coord, { units: this.config.distanceUnit || 'kilometers' });
                            dist += d;
                            arr.push(d);
                        }
                        previousCoord = coord;
                    });
                    return {
                        [`output`]: isNaN(dist) ? null : dist,
                        arrOutput: arr,
                    };
                }
                return {
                    [`output`]: null,
                    arrOutput: null,
                };
            }
            catch (e) { }
            return null;
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.LineDistanceCalcNode = LineDistanceCalcNode;
LineDistanceCalcNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Line Distance Calc',
    isIdempotent: true,
    primaryCategory: 'Geography',
};
//# sourceMappingURL=LineDistanceCalc.js.map